"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const avax2x_png_1 = __importDefault(require("../../static/assets/avax2x.png"));
const wbnb2x_png_1 = __importDefault(require("../../static/assets/wbnb2x.png"));
const eth2x_png_1 = __importDefault(require("../../static/assets/eth2x.png"));
const matic2x_png_1 = __importDefault(require("../../static/assets/matic2x.png"));
const chainList = {
    avax_blockchain: { alt: 'Avalanche Blockchain', src: avax2x_png_1.default },
    bnb_blockchain: { alt: 'BNB Smart Chain', src: wbnb2x_png_1.default },
    eth_blockchain: { alt: 'Ethereum Blockchain', src: eth2x_png_1.default },
    matic_blockchain: { alt: 'Polygon Blockchain', src: matic2x_png_1.default },
};
exports.default = chainList;
//# sourceMappingURL=chainList.js.map